import React, { useEffect, useState } from "react";
import { fetchFeatured } from "@/lib/featuredPro";
import { FeaturedSpotlight } from "@/components/featured/FeaturedSpotlight";

const PLACEMENT = "MARKETPLACE_FEATURED_PROFESSIONALS";
const INTENT = { "For Sale": "buying", "For Rent": "renting", "Unit Hosting": "stays" };

// Contextual Featured Professionals inside the Marketplace results. Hidden when nobody relevant.
export function MarketplaceFeaturedPros({ city, locationCode, listingType, propertyType, saleType }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const params = { placement: PLACEMENT, listing_type: listingType };
    if (city) params.city = city;
    if (locationCode) params.location_code = locationCode;
    if (propertyType) params.property_type = propertyType;
    if (saleType) params.sale_type = saleType;
    let live = true;
    fetchFeatured(params).then((l) => live && setItems(l)).catch(() => live && setItems([]));
    return () => { live = false; };
  }, [city, locationCode, listingType, propertyType, saleType]);
  if (!items.length) return null;
  const intent = INTENT[listingType];
  const subtitle = `Professionals who can help with ${intent || "properties"}${city ? ` in ${city}` : ""}`;
  return (
    <FeaturedSpotlight tid="market-featured-pros" placement={PLACEMENT} items={items} subtitle={subtitle}
      className="my-10 rounded-3xl" inner="px-4 py-4 sm:px-6 sm:py-4" />
  );
}

export default MarketplaceFeaturedPros;
